import React from 'react';
import style from './Admin.module.css';
import { useState, useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { useGetQuestionsQuery } from '../../redux/questionsApi';
import RotateLoader from "react-spinners/ScaleLoader";
import { EditQuestionCard, Modal } from '../../components';

const override = {
    display: "block",
    margin: "10px auto",
    borderColor: "red",
};

const Admin = () => {

    const [isLogged, setIsLogged] = useState(true);

    const [questions, setQuestions] = useState([]);
    const { data, isFetching } = useGetQuestionsQuery();

    useEffect(() => {
        if(!isFetching) {
            setQuestions(Object.values(data));
        }
    }, [data]);

    if(!isLogged) {
        return <Navigate to='/login'/>
    }

    return (
        <div className={style.container}>
            <h1>Preguntas</h1>
            <div className={style.loader}>
                <RotateLoader color={"#660099"} loading={isFetching} cssOverride={override} size={20}/>
            </div>
            {
                questions?.map((question, index) => (
                    <div className={style.container_preguntas} key={index}>
                        <EditQuestionCard question={question}/>
                    </div>
                ))
            }
        </div>
    )
}

export default Admin